/* @flow */

export const IOC_ENRICHMENT_ENDPOINT = '/services/cpe';
export const INDICATOR_LIST_ENDPOINT = '/services/indicators';

export const INDICATOR_EXPORT_ENDPOINT = '/services/indicators/export-results.csv';



// WEBPACK FOOTER //
// ./src/app/modules/indicators/constants.js